import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=36f16342&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=36f16342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f16342",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartEmpty: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Empty.vue').default,CartItem: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Item.vue').default,CartSummary: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Summary.vue').default})
